import { deserializeHash } from "@formant/core/common/serializeHash";
import { SetSelectedDateAction } from "@formant/rectangle-sdk/src/enums/selected-date.enum";

export interface IRectangleStoreStateForEventSeek {
    setSelectedDate: (action: SetSelectedDateAction, arg: Date) => void;
    setIsLive: (arg: boolean) => void;
    setIsPlaying: (arg: boolean) => void;
    setEventSidebarIsOpen: (arg: boolean) => void;
    setSelectedEventId: (arg: string | undefined) => void;
}

function parseHash(hash: string): Record<string, any> {
    const raw = hash.startsWith("#") ? hash.slice(1) : hash;
    if (!raw) {
        return {};
    }
    try {
        return deserializeHash(raw) as Record<string, any>;
    } catch {
        return {};
    }
}

function toDate(value: unknown): Date | undefined {
    if (value instanceof Date) {
        return isNaN(value.getTime()) ? undefined : value;
    }
    if (typeof value === "number" || typeof value === "string") {
        const d = new Date(value);
        return isNaN(d.getTime()) ? undefined : d;
    }
    return undefined;
}

/**
 * Coherence device view uses rectangle-sdk state (not ObserveStore).
 * This bridges legacy `#time` / `#selectedEventId` hash parameters into the
 * rectangle-sdk store so that clicking an event from the DEVICE-EVENTS view
 * actually seeks on the device timeline.
 */
export function applyEventHashToRectangleStore(
    hash: string,
    state: IRectangleStoreStateForEventSeek,
): boolean {
    const data = parseHash(hash);
    const selectedEventId =
        typeof data.selectedEventId === "string"
            ? data.selectedEventId
            : undefined;
    const time = toDate(data.time);

    // Nothing to apply
    if (!selectedEventId && !time) {
        return false;
    }

    // Ensure we land in a paused/non-live state for deterministic seeking
    state.setIsLive(false);
    state.setIsPlaying(false);

    if (time) {
        state.setSelectedDate(SetSelectedDateAction.Default, time);
    }

    if (selectedEventId) {
        state.setEventSidebarIsOpen(true);
        state.setSelectedEventId(selectedEventId);
    }

    return true;
}
